var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header text-center text-lg-left"},[_c('div',{staticClass:"font-weight-bold",class:_vm.$vuetify.breakpoint.smAndUp ? 'title' : 'body-1'},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }